import React from 'react'
import {MdKeyboardArrowRight} from 'react-icons/md';
import {MdKeyboardArrowDown} from 'react-icons/md';
import Gifting_Products_Container from './Gifting_Products_Container';
const GiftingProducts = () => {
  return (
    <div className='w-full p-2 lg:p-4 bg-white '>
       <div className='w-full flex justify-between items-center px-2'>
       <h1 className='text-lg font-semibold '>All Products</h1>
       <div className='group lg:px-0 md:basis-4/12 lg:basis-3/12 py-2 border border-gray-500 text-sm relative'> <span className='pl-2'>Sort :</span>  <span className='text-sm font-semibold pr-2 '>Recommended</span>
        <span className='hidden md:block md:absolute right-4 top-3'><MdKeyboardArrowRight className='block'/></span>
        <div className='absolute top-9 hidden group-hover:block border border-gray-500 bg-white w-full '>
          <ul>
            <li className=' hover:bg-gray-200 '><a className='p-2 block w-full' href="/">Price : Hight to Low</a>  </li>
            <li className=' hover:bg-gray-200'><a  className='p-2 block w-full'href="/">Price : Low to High</a>  </li>
            <li className=' hover:bg-gray-200'><a  className='p-2 block w-full'href="/">Popularity</a> </li>
            <li className=' hover:bg-gray-200'><a  className='p-2 block w-full'href="/"> What's New</a></li>
            <li className=' hover:bg-gray-200'> <a className='p-2 block w-full' href="/">Cutsomer Rating</a></li>
          </ul>
        </div>
       </div>
       </div>
       <div>
           <Gifting_Products_Container/>
       </div>
    </div>
  )
}

export default GiftingProducts